import React from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup'; 
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Checked from '../Components/Checked';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTie,
        faUserCheck,
        faCalendarDay,
        faCalendarWeek } from '@fortawesome/free-solid-svg-icons';

export default function CensoFilters(props)
{
    if (props.show)
    {
        return(
            <Row className="p4">
                <Col md={12} lg={6}>
                    <TypeFilters
                        pstatus={props.pstatus}
                        pservice={props.pservice}
                        colaps={props.colaps}
                        setPstatus={(v) => props.setPstatus(v)}
                        setPservice={(v) => props.setPservice(v)}
                        setColaps={(ison) => props.setColaps(ison)}
                        TxtService={props.TxtService}
                        TxtStatus={props.TxtStatus}
                        groupLabel={props.groupLabel}/>
                </Col>
                <Col xs={12} lg={6}>
                    <DateFilters
                        daterange={props.daterange} 
                        dateday={props.dateday} 
                        setDateday={(v) => props.setDateday(v)}
                        setDaterange={(v) => props.setDaterange(v)}  
                        show={props.pstatus!==0}
                        TxtDate={props.TxtDate}/>
                </Col>
            </Row>
        );
    } else {
        return(<></>);
    }
}

function TypeFilters(props)
{
    const objstates = props.TxtStatus;
    const states = [];
    for(var c in objstates) {
        states.push(objstates[c]);
     }
    const liststates = states.map((state, index) =>
        <Dropdown.Item eventKey={(index+2).toString()} key={index}
                        onSelect={() => props.setPstatus(index)} 
                        active={props.pstatus===index}>
                            {state}
        </Dropdown.Item>
    );

    return(
        <Row className="mr-0 ml-0">
            <Col xs={6} sm={4}>
                <span className="text-muted">colapasar</span><br/>
                <ToggleButtonGroup type="checkbox" className="mb-2">
                    <ToggleButton variant="outline-dark" 
                        value={true}
                        checked={props.colaps}
                        onChange={() => props.setColaps(!props.colaps)}>
                        <Checked ison={props.colaps}/> {props.groupLabel}
                    </ToggleButton>
                </ToggleButtonGroup>
            </Col>
            <Col xs={6} sm={4}>
                <span className="text-muted">Servicio med.</span><br/>
                <Row className="mr-0 ml-0">
                    <FontAwesomeIcon className="fsp24 vac" icon={faUserTie}/>
                    <span>&nbsp;</span><span>&nbsp;</span>
                    <DropdownButton variant="secondary" title={props.TxtService[props.pservice]}>
                        <Dropdown.Item eventKey="2" 
                            onSelect={() => props.setPservice(0)} 
                            active={props.pservice===0}>Todos</Dropdown.Item>
                        <Dropdown.Item eventKey="3"
                            onSelect={() => props.setPservice(1)} 
                            active={props.pservice===1}>Asegurado</Dropdown.Item>
                        <Dropdown.Item eventKey="4"
                            onSelect={() => props.setPservice(2)} 
                            active={props.pservice===2}>Particular</Dropdown.Item>
                    </DropdownButton>
                </Row>
            </Col>
            <Col xs={8} sm={4}>
                <span className="text-muted">Estado</span><br/>
                <Row className="mr-0 ml-0">
                    <FontAwesomeIcon className="fsp24 vac" icon={faUserCheck}/>
                    <span>&nbsp;</span><span>&nbsp;</span>
                    <DropdownButton variant="secondary" title={props.TxtStatus[props.pstatus]}>
                        {liststates}
                    </DropdownButton>
                </Row>
            </Col>
        </Row>
    );
}

function DateFilters(props)
{
    if (props.show)
    {
        return(
            <Row className="m4">
                <Col xs={6} sm={4} md={4} lg={3}>
                    <span className="text-muted">Fecha</span><br/>
                    <Row className="pl16 mr-0 ml-0">
                        <FontAwesomeIcon className="fsp24 vac" icon={faCalendarWeek}/>
                        <span>&nbsp;</span><span>&nbsp;</span>
                        <DropdownButton variant="secondary" title={props.TxtDate[props.daterange]} value>
                            <Dropdown.Item eventKey="2" 
                                    onSelect={() => props.setDaterange(0)}
                                    active={props.daterange===0}>{props.TxtDate[0]}</Dropdown.Item>
                            <Dropdown.Item eventKey="3" 
                                    onSelect={() => props.setDaterange(1)}
                                    active={props.daterange===1}>{props.TxtDate[1]}</Dropdown.Item>
                            <Dropdown.Item eventKey="3" 
                                    onSelect={() => props.setDaterange(2)}
                                    active={props.daterange===2}>{props.TxtDate[2]}</Dropdown.Item>
                            <Dropdown.Item eventKey="4"
                                    onSelect={() => props.setDaterange(3)} 
                                    active={props.daterange===3}>{props.TxtDate[3]}</Dropdown.Item>
                        </DropdownButton>
                    </Row>
                </Col>
                <Col xs={6} sm={6} md={6} lg={9}>
                    <SpecificDateFilter 
                    dateday={props.dateday} 
                    setDateday={(v) => props.setDateday(v)}
                    show={props.daterange===3}/>
                </Col>
            </Row>
            );
    } else {
        return(<></>);
    }   
}

function SpecificDateFilter(props)
{
    if (props.show)
    {
        return(
            <Row className="mr-0 ml-0">
                <span className="text-muted">Elegir dia</span><br/>
                <InputGroup>
                <InputGroup.Prepend>
                    <InputGroup.Text id="basic-addon1">
                        <FontAwesomeIcon icon={faCalendarDay}/>
                    </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                placeholder="Elejir Dia"
                aria-label="Date"
                aria-describedby="basic-addon1"
                type="date"
                max={moment(new Date()).format('YYYY-MM-DD')}
                value={moment(props.dateday).format('YYYY-MM-DD')}
                onChange={e => props.setDateday(e.target.value)}
                />
                </InputGroup>
            </Row>
        );
    } else {
        return(<></>);
    }
}